import React, { useState, useEffect } from "react";
import { get } from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";
import { LargeCard } from "../Cards/LargeCard";
import Swal from "sweetalert2";

const usersheaders = [
  "Código SAP",
  "Descripción",
  "Código Proveedor",
  "Proveedor",
  "% de Tasa",
  "Fecha",
  "Usuario",
];

export const CrudServiceFee = ({ project }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const getData = async (search, statusPage) => {
    setLoading(true);
    const response = await get(
      `/skus?page=${statusPage}&search=${search}&Nit=${project}&skusServiceFee=True&sortBy=${"HistoryDate"}&order=${"DESC"}&limit=${itemsPerPage}`
    );
    if (response.answer) {
      setTotalItems(response.pagination.totalItems);
    } else {
      setTotalItems(0);
    }
    setData(response.items);
    setLoading(false);
  };

  const convertDataToArray = () => {
    try {
      return data.map((item) => [
        item.CodeSap.toUpperCase(),
        item.SkuDescription.toUpperCase(),
        item.Nit.toUpperCase(),
        item.ProjectName.toUpperCase(),
        parseFloat(item.PercentFee).toFixed(2) + "%",
        item.HistoryDate,
        item.User.split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" "),
      ]);
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    } else {
      setChangePage(false);
    }
  }, [page, initialRender]);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }

    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [itemsPerPage]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "refresh":
        getData("", page);
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  return (
    <>
      <LargeCard
        name={
          <span style={{ display: "flex", alignItems: "center" }}>
            Tasa de servicio
            <i
              className="fas fa-info-circle"
              onClick={() => {
                Swal.fire({
                  title: "Cálculo de la Tasa de Servicio",
                  html:
                    '<p style="text-align: justify;">Este proceso se ejecuta diariamente a las 10:00 p.m, considerando todas las actualizaciones en la tabla de Skus.</p>' +
                    "<ol>" +
                    '<li style="text-align: justify; margin-bottom: 10px;">Se recopila el porcentaje de inventario de cada SKU de un proveedor.</li>' +
                    '<li style="text-align: justify; margin-bottom: 10px;">Calculamos el promedio de inventario por Código SAP.</li>' +
                    '<li style="text-align: justify; margin-bottom: 10px;">Verificamos si el inventario de cada SKU es superior al 75%.</li>' +
                    '<li style="text-align: justify; margin-bottom: 10px;">Sumamos los SKU que cumplen la condición del 75%.</li>' +
                    '<li style="text-align: justify; margin-bottom: 10px;">Calculamos el promedio ponderado del inventario para cada Sku.</li>' +
                    "</ol>",
                  icon: "info",
                  confirmButtonText: "Aceptar",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                });
              }}
              onMouseOver={() => {
                document.body.style.cursor = "pointer";
              }}
              onMouseOut={() => {
                document.body.style.cursor = "default";
              }}
              style={{ marginLeft: "5px", fontSize: "1rem", color: "#146284" }}
            />
          </span>
        }
        headers={usersheaders}
        loading={loading}
        data={convertDataToArray()}
        totalItems={totalItems}
        customTable={false}
        setPage={setPage}
        page={page}
        setChangePage={setChangePage}
        setPressedButton={setPressedButton}
        setSearch={setSearch}
        cState={false}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
    </>
  );
};
